<div class="canvas-outer">
  <div id="container">
  </div>    
  <a class="delete-icon" title="Delete image" href="javascript:void(0)" style="display: none;">
    <i class="fa fa-remove" aria-hidden="true"></i>
  </a>
  <div class="upload-btn-wrapper">  
    <div id="drop-region">
      <i class="fa fa-cloud-upload fa-2x" aria-hidden="true"></i> 
      <div class="drop-message">
        Drag & Drop a logo or click to upload
      </div>
    </div>
  </div>
</div>
